import React from 'react';

/**
 * GlassFilterDefs
 *
 * Mounts the shared SVG filter used by the enhanced frosted-glass surfaces
 * (see liquidGlass.css). feTurbulence generates a static, gentle noise field
 * that feDisplacementMap uses to subtly refract the backdrop - so glass
 * panels look like they have real thickness rather than a flat blur.
 *
 * The filter is referenced from `backdrop-filter: ... url(#bp-glass-distortion)`
 * which distorts the BACKDROP ONLY, leaving foreground text/icons crisp. It is
 * applied only on engines that actually render it (see lib/liquidGlass.js);
 * everywhere else the CSS fallback (blur + tint + edge lighting) is used.
 *
 * Rendered once at the app root. Kept 0x0 and visually hidden (NOT display:none,
 * which disables filters in some engines).
 */
const GlassFilterDefs = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    width="0"
    height="0"
    style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden', pointerEvents: 'none' }}
  >
    <defs>
      <filter
        id="bp-glass-distortion"
        x="-15%"
        y="-15%"
        width="130%"
        height="130%"
        colorInterpolationFilters="sRGB"
      >
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.006 0.009"
          numOctaves="2"
          seed="4"
          stitchTiles="stitch"
          result="noise"
        />
        <feGaussianBlur in="noise" stdDeviation="0.8" result="softNoise" />
        <feDisplacementMap
          in="SourceGraphic"
          in2="softNoise"
          scale="16"
          xChannelSelector="R"
          yChannelSelector="G"
        />
      </filter>
    </defs>
  </svg>
);

export default GlassFilterDefs;
